import { mapValues, zipObject } from 'lodash-es'
import { scan } from '../../../lib/array-utils'
import { moveLabels } from '../moveLabels'
import { ChallengesMap, CHALLENGES } from '../../../lib/constants'

/*
 /$$$$$$$   /$$$$$$  /$$$$$$$   /$$$$$$
| $$__  $$ /$$__  $$| $$__  $$ /$$__  $$
| $$  \ $$| $$  \ $$| $$  \ $$| $$  \__/
| $$$$$$$ | $$$$$$$$| $$$$$$$/|  $$$$$$
| $$__  $$| $$__  $$| $$__  $$ \____  $$
| $$  \ $$| $$  | $$| $$  \ $$ /$$  \ $$
| $$$$$$$/| $$  | $$| $$  | $$|  $$$$$$/
|_______/ |__/  |__/|__/  |__/ \______/
*/
export interface CountryDrawParams {
  position: ChallengesMap<number>
  length: ChallengesMap<number>
}

export function getCountryDrawParams(
  country: ChallengesMap<number>,
  height: number
): CountryDrawParams {
  const lengths = CHALLENGES.map((challenge) => country[challenge] * height)
  const positions = [0, ...scan(lengths, (pos, length) => pos + length, 0)]

  return {
    length: zipObject(CHALLENGES, lengths) as ChallengesMap<number>,
    position: zipObject(CHALLENGES, positions) as ChallengesMap<number>,
  }
}

/*
 /$$        /$$$$$$  /$$$$$$$  /$$$$$$$$ /$$        /$$$$$$
| $$       /$$__  $$| $$__  $$| $$_____/| $$       /$$__  $$
| $$      | $$  \ $$| $$  \ $$| $$      | $$      | $$  \__/
| $$      | $$$$$$$$| $$$$$$$ | $$$$$   | $$      |  $$$$$$
| $$      | $$__  $$| $$__  $$| $$__/   | $$       \____  $$
| $$      | $$  | $$| $$  \ $$| $$      | $$       /$$  \ $$
| $$$$$$$$| $$  | $$| $$$$$$$/| $$$$$$$$| $$$$$$$$|  $$$$$$/
|________/|__/  |__/|_______/ |________/|________/ \______/
*/

interface LabelsDrawParams {
  position: ChallengesMap<number>
  opacity: ChallengesMap<number>
}

export const getLabelsDrawParams = (
  country: ChallengesMap<number>,
  height: number
): LabelsDrawParams => {
  const { position: countriesPositions } = getCountryDrawParams(country, height)

  const visibleChallenges = CHALLENGES.filter((challenge) => country[challenge] !== 0)

  // MOVE LABELS TO AVOID OVERLAP
  const ys = visibleChallenges.map((challenge) => countriesPositions[challenge])
  moveLabels(ys, height)

  return {
    position: { ...countriesPositions, ...zipObject(visibleChallenges, ys) },
    opacity: mapValues(country, (value) => (value === 0 ? 0 : 1)),
  }
}
